import React from 'react';

/**
 * The comment this approver left with their decision, beneath the row's title.
 *
 * PLAIN REACT CHILDREN, deliberately. The approver tooltip renders its own copy
 * of this same text by concatenating an HTML string, so it has to escape by
 * hand; here React escapes it. That difference is the reason this does not reuse
 * the tooltip's path for what looks like the same job.
 *
 * A PENDING ROW RENDERS NOTHING AT ALL, not an empty line: the user has taken no
 * decision on it, so there is no comment of theirs to preview.
 *
 * Clamped in CSS rather than cut in JS. The full text belongs in the detail
 * pop-up, and a character count guessed here would cut mid-word at every column
 * width the table is read at.
 */
export default function ApprovalCommentLine({ comment }) {
    if (!comment) {
        return null;
    }

    return <span className="tw-mt-0.5 tw-block tw-text-2xs tw-text-charcoal-60 tw-line-clamp-2">{comment}</span>;
}
